import { DefaultService } from './DefaultService'

export default class TipoFreteService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(page = 0, limit = 50, ...params) {
        return this._http.get(encodeURI(`${this._env}/shippingtype/order/all.json?page=${page}&limit=${limit}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}